import React from 'react';
import './sec1-p2.css'
import Herotext from '../components/common/hero-text';

const Sec1p2 = () => {
    return ( 
        <section className='sec1-p2'>
            <figure className='background-sec1-p2'>
                <article className='big-container-sec1-p2'>
                    <article className='container-sec1-p2'>
                         <Herotext title='Properties' para='Find your ideal home with ease. Browse listings,
                          compare options, and find the perfect fit.' />
                    </article>
                </article>
            </figure>
        </section>
     );
}
 
export default Sec1p2;